import _ from 'lodash';
export const allProducts = [
	{
		//- only in tank
		display : 'E85',
		value : 'e85'
	}, {
		//- only at terminal
		display : 'Ethanol (ETOH)',
		value : 'etoh',
	}, {
		display : 'Regular Unleaded (UNL)',
		value : 'unl'
	}, {
		display : 'Midgrade (MidUNL)',
		abbreviation : 'MidUNL',
		value : 'midunl'
	}, {
		display : 'Premium (PreUNL)',
		abbreviation : 'PreUNL',
		value : 'preunl'
	}, {
		display : 'Biodiesel 100% (B00)',
		value : 'b00'
	}, {
		display : 'Biodiesel 99% (B99)',
		value : 'b99'
	}, {
		display : 'Biodiesel 20% (B20)',
		value : 'b20'
	}, {
		display : 'Biodiesel 10% (B10)',
		value : 'b10'
	}, {
		display : 'Biodiesel 5% (B5)',
		value : 'b05'
	}, {
		display : 'Renewable  Diesel (R99)',
		value : 'r99'
	}, {
		display : 'Renewable  Diesel (R95)',
		value : 'r95'
	}, {
		display : 'Renewable  Diesel (RD80/B20)',
		value : 'rd80/b20'
	}, {
		display : 'Ultra Low Sulfur Diesel (ULSD)',
		value : 'ulsd'
	}, {
		display : 'Red Dyed Diesel (RedULSD)',
		value : 'redulsd'
	},
];

export const terminalProducts = allProducts;

/*
export const bulkProducts = _.filter(allProducts, ({value}) => {
	return value !== 'e85';
});
 */

export const stationTankProducts = _.filter(allProducts, ({value}) => {
	return value !== 'etoh';
});

export const invoiceSearchProducts = _.filter(allProducts, ({value}) => {
	return value !== 'etoh';
});

const productMap = _.keyBy(allProducts, 'value');
export const valueToDisplay = (value) => {
	if (value === 'none') {
		return 'None';
	} else {
		return _.get(productMap, `${value}.display`, 'Missing');
	}
};

export const valueToAbbreviation = (value) => {
	const abbreviation =  _.get(productMap, `${value}.abbreviation`);
	if (abbreviation) {
		return abbreviation;
	}
	return (value) ? value.toUpperCase() : 'Missing';
};
